<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
            <div class="form container px-2">
                <h5><b>A. PERSONAL DATA</b></h5>
                <div class="mb-4 mt-3">
                    <div>
                        <p class="mb-0"><b>A.1 &nbsp; &nbsp;Name (Surname Last):</b></p>
                    </div>
                    <div>
                        <input type="text" class="form-control pb-0" name="name" v-model="name">
                    </div>
                </div>

                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>A.2 &nbsp; &nbsp;File Number (SP. No.):</b></p>
                    </div>
                    <div>
                        <input type="text" class="form-control pb-0" name="fileNum" v-model="fileNum">
                    </div>
                </div>

                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>A.3 &nbsp; &nbsp;Present status, grade level, and salary:</b></p>
                    </div>
                    <div class="text-start mt-2">
                        <div>
                            <select id="presentStatus" name="presentStatus" v-model="presentStatus">
                                <option value="Professor">Professor</option>
                                <option value="Readers">Reader</option>
                                <option value="Senior Lecturer">Senior Lecturer</option>
                                <option value="Lecturer I">Lecturer I</option>
                                <option value="Lecturer II">Lecturer II</option>
                                <option value="Assistant Lecturer" selected>Assistant Lecturer</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>A.4 &nbsp; &nbsp;Faculty:</b></p>
                    </div>
                    <div class="text-start mt-2">
                        <select id="faculty" name="faculty" v-model="faculty">
                            <option value="Agriculture" selected>Agriculture</option>
                            <option value="Basic Medical Sciences">Basic Medical Sciences</option>
                            <option value="Basic Clinical Sciences">Basic Clinical Sciences</option>
                            <option value="Clinical Sciences">Clinical Sciences</option>
                            <option value="Communication and Media Studies">Communication and Media Studies</option>
                            <option value="Engineering">Engineering</option>
                            <option value="Education">Education</option>
                            <option value="Environmental Sciences">Environmental Sciences</option>
                            <option value="Humanities">Humanities</option>
                            <option value="Law">Law</option>
                            <option value="Management Sciences">Management Sciences</option>
                            <option value="Science">Science</option>
                            <option value="Social Sciences">Social Sciences</option>
                        </select>
                    </div>
                </div>

                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>A.5 &nbsp; &nbsp;Department:</b></p>
                    </div>
                    <div>
                        <input type="text" class="form-control pb-0" name="department" v-model="department">
                    </div>
                </div>

                <!-- first employment -->
                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>
                            A.6 &nbsp; &nbsp;Date, status of level of First
                            Appointment in this University:
                        </b></p>
                    </div>
                    <div>
                        <textarea v-model="firstEmployment" type="text" class="form-control pb-0" rows="4"></textarea>
                    </div>
                </div>

                <!-- last employment -->
                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>A.7 &nbsp; &nbsp;Last change in status in this University with date:</b></p>
                    </div>

                    <div>
                        <textarea v-model="lastEmployment" type="text" class="form-control" rows="4"></textarea>
                    </div>
                </div>

                <div class="mb-4">
                    <div>
                        <p class="mb-0"><b>
                            A.8 &nbsp; &nbsp;Reference and date of notification concerning any more recent consideration of change in status:
                        </b></p>
                    </div>
                    <div>
                        <textarea id="statusNotification" v-model="statusNotification" type="text" class="form-control pb-0" rows="4"></textarea>
                    </div>
                </div>

                <div class="mb-5">
                    <div>
                        <p class="mb-0">
                            <b>
                                A.9 &nbsp; &nbsp;Date of confirmation of appointment:
                            </b>
                        </p>
                    </div>
                    <div class="mt-3">
                        <input v-model="confirmationDate" type="date" class="form-control picker" id="confirmationDate"
                            aria-describedby="emailHelp" required>
                    </div>
                </div>

                <div class="d-flex flex-row-reverse pb-5">
                    <button @click="saveSection()" type="button" class="btn btn-success">Save & Continue</button>
                </div>
            </div>
        </div>
    </Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionA',
    emits: ['toggleLoader', 'setSection'],
    data() {
        return {
            candidate: '',
            name: '',
            fileNum: '',
            presentStatus: '',
            faculty: '',
            department: '',
            firstEmployment: '',
            lastEmployment: '',
            statusNotification: '',
            confirmationDate: ''
        }
    },
    mounted() {
        this.$emit('setSection', 'Section A');
        this.setData()
    },
    methods: {
        async saveSection() {
            this.$emit('toggleLoader');

            var dataDetails = {
                name: this.name,
                fileNum: this.fileNum,
                presentStatus: this.presentStatus,
                faculty: this.faculty,
                department: this.department,
                firstEmployment: this.firstEmployment,
                lastEmployment: this.lastEmployment,
                statusNotification: this.statusNotification,
                confirmationDate: this.confirmationDate
            }

            const candidate = await DataService.saveData(dataDetails)

            if (candidate) { 
                this.candidate = candidate;
                this.$router.push('/sectionb');
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');
            
            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id)

            if (candidate) {
                this.candidate = candidate;
                this.name = candidate.name ? candidate.name : ''
                this.fileNum = candidate.fileNum ? candidate.fileNum : ''
                this.presentStatus = candidate.presentStatus ? candidate.presentStatus : ''
                this.faculty = candidate.faculty ? candidate.faculty : ''
                this.department = candidate.department ? candidate.department : ''
                this.firstEmployment = candidate.firstEmployment ? candidate.firstEmployment : ''
                this.lastEmployment = candidate.lastEmployment ? candidate.lastEmployment : ''
                this.statusNotification = candidate.statusNotification ? candidate.statusNotification : ''
                this.confirmationDate = candidate.confirmationDate ? candidate.confirmationDate : ''
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>